// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"0fc2759f","833":"fc9bc529","944":"0fc2759f"}[chunkId] + ".chunk.css";
};